import React from "react";
import "../../index.css";
import "./AboutUs.css";
import { Outlet, useNavigate } from "react-router";

const AboutUsPage = () => {
  // const navigate = useNavigate();
  return (
    <>
      <div className="layout about-layout gradient-background">
        <div className="container main-container">
          <h1 className="title main-about-us-title">ABOUT US</h1>
          <p className="subtitle main-about-us-subtitle">
            Bumi Agung Sukses, which is also known as BAS, was established in
            2012 as a retail store offering a wide range of products from a
            highly respected bicycle brand. With persistence and hard work, we
            were able to expand our business from solely distributing one brand
            to carrying multiple top-tier brands and expanding our dealer
            network throughout Indonesia. However, we didn't stop there. As a
            team, we are constantly striving to better ourselves and our
            company, and we remain committed to improving our services every
            day.
          </p>
        </div>
        <div className="container vision-mission-container">
          <h1 className="title vision-title">VISION</h1>
          <p className="subtitle vision-subtitle">
            To become Indonesia's leading and most trusted bike retail,
            inspiring a healthier and more sustainable future
          </p>
          <h1 className="title mission-title">MISSION</h1>
          <p className="subtitle mission-subtitle">
            <li className="mission-item">
              Offer a wide range of high-quality bikes that meet the diverse
              needs of our customers
            </li>
            <li className="mission-item">
              Build trust through integrity, transparency, and excellent
              customer service
            </li>
            <li className="mission-item">
              Foster innovation to provide cutting-edge products and improve the
              biking experience
            </li>
            <li className="mission-item">
              Strengthen networks with partners and communities to promote
              sustainable and active lifestyles
            </li>
            <li className="mission-item">
              Empower our team to grow professionally, collaborate effectively,
              and achieve excellence in all areas
            </li>
          </p>
        </div>
        {/* <div
          className="button organization-button"
          onClick={() => navigate("organization", { relative: "path" })}
        >
          Go to organization
        </div>
        <Outlet /> */}
      </div>
    </>
  );
};

export default AboutUsPage;
